export const version: string = '0.6.0';
